import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";

import SelectMenu from "./dropDown";
import { Link } from "react-router-dom";
import logoHead from "./logo/cder_logo.png";

export const Register = ({ setAuth }) => {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [passConfirm, setPassConfirm] = useState("");
  const [name, setName] = useState("");
  const [position, setPosition] = useState("");

  const [validMatch, setValidMatch] = useState("false");
  const [validEmail, setValidEmail] = useState("false");
  const [validPass, setValidPass] = useState("false");
  const [validName, setValidName] = useState("false");

  const options = [
    { value: "1", label: "Option 1" },
    { value: "2", label: "Option 2" },
  ];

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleChangePass = (e) => {
    setPass(e.target.value);
  };

  const handleChangePassConfirm = (e) => {
    setPassConfirm(e.target.value);
  };

  const handleChangeName = (e) => {
    setName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("1");

    // Get the values of the email and password variables from the state
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            email,
            pass,
          }),
        }
      );

      const parseRes = await response.json();

      localStorage.setItem("token", parseRes.token);
      setAuth(true);
      toast("Accès réussi!");

      // Do something with the user object
    } catch (err) {
      console.error(err.message);
    }

    // Update the state of the email and password variables
    setEmail("");
    setPass("");
    setName("");
  };

  useEffect(() => {
    const match = pass === passConfirm;
    setValidMatch(match);
  }, [pass, passConfirm]);

  useEffect(() => {
    const validP = pass.length > 0 ? true : false;
    setValidPass(validP);
  }, [pass]);

  useEffect(() => {
    const validE = email.includes("@") ? true : false;
    setValidEmail(validE);
  }, [email]);

  useEffect(() => {
    const validN = name.length > 0 ? true : false;
    setValidName(validN);
  }, [name]);
  return (
    <>
      <div className=" m-0  text-white main-banner">
        <div className="head-banner-logo">
          <img src={logoHead} alt="logoHead" />
        </div>
        <div className="banner-text-1">
          <p>
            Popular Democratic Republic of Algeria Ministry of Higher Education
            & Scienth1ific Research General Directorate for Scientific Research
            and Technological Development
          </p>
        </div>
        <div className="banner-text-2">
          <h5>Renewable Energy Development Center</h5>
        </div>
      </div>

      <div class="topnav container-fluid mb-2">
        <div className="topnav">
          <a href="#"></a>
          <a href="#"></a>
          <a href="#"></a>
        </div>
      </div>

      <div className="log-in">
        <h1 className="text-center my-5">S'enregistrer</h1>
        <form className="log-in-elements" onSubmit={handleSubmit}>
          <div className="">
            <label className="form-label" htmlFor="name">
              Nom et prenom
            </label>
            <input
              className="form-control"
              value={name}
              type="text"
              placeholder="Nom Complet"
              id="name"
              name="name"
              onChange={handleChangeName}
            />
          </div>
          <div className="mb-3 mt-3">
            <label className="form-label" htmlFor="email">
              Email
            </label>
            <input
              className="form-control"
              value={email}
              autoComplete="off"
              type="email"
              placeholder="votreEmail@gmail.com"
              id="email"
              name="email"
              onChange={handleChangeEmail}
            />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="password">
              Mot de pass
            </label>
            <input
              className="form-control"
              value={pass}
              type="password"
              placeholder="*****"
              id="password"
              name="password"
              onChange={handleChangePass}
            />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="password-confirm">
              Comfirmez le Mot de pass
            </label>
            <input
              className="form-control"
              value={passConfirm}
              type="password"
              placeholder="*****"
              id="password-confirm"
              name="password-confirm"
              onChange={handleChangePassConfirm}
            />
          </div>

          <button
            className="btn btn-primary mt-3"
            type="submit"
            disabled={
              !validMatch || !validEmail || !validPass || !validPass
                ? true
                : false
            }
          >
            Log in
          </button>
          <Link to={"/login"} className="btn mt-3 p-2 ms-3">
            J'ai deja un compte, Log-in
          </Link>
        </form>
      </div>
    </>
  );
};
